import React from 'react'
import { Grid } from "@mui/material"
import { AppFormSection } from "@components"
import UserOnlyExportSwitch from "Pages/Admin/Users/CreateDrawer/Content/Config/OnlyReport"
import UserIsMasterSwitch from "Pages/Admin/Users/CreateDrawer/Content/Config/IsMaster"
import UserFeaturesField from "Pages/Admin/Users/CreateDrawer/Content/Config/Features"
import SelectorWithSkeleton from "Pages/Admin/Users/CreateDrawer/Content/SelectorSkeleton"
import UserMasterSelector from "Pages/Admin/Users/CreateDrawer/Content/Config/MasterSelector"
import UserDateFormat from "Pages/Admin/Users/CreateDrawer/Content/Config/DateFormat"
import UserDateFormatGeneration from "Pages/Admin/Users/CreateDrawer/Content/Config/DateFormatGeneration"


export default function UserConfigSection({ isLoading }) {

	return <AppFormSection icon="gear" title="User Config">
		<Grid container spacing={2}>
			<SelectorWithSkeleton SelectorComponent={UserFeaturesField} isLoading={isLoading} xs={5}/>
			<Grid item xs={6}/>
			<SelectorWithSkeleton SelectorComponent={UserOnlyExportSwitch} isLoading={isLoading} xs={2.5}/>
			<SelectorWithSkeleton SelectorComponent={UserIsMasterSwitch} isLoading={isLoading} xs={2.5}/>
			<Grid item xs={4.5}/>
			<SelectorWithSkeleton SelectorComponent={UserMasterSelector} isLoading={isLoading} xs={4}/>
			<SelectorWithSkeleton SelectorComponent={UserDateFormat} isLoading={isLoading} xs={4}/>
			<SelectorWithSkeleton SelectorComponent={UserDateFormatGeneration} isLoading={isLoading} xs={4}/>
		</Grid>
	</AppFormSection>
}
